import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API;

const store = {
  namespaced: true,
  state: {
    akses: null
  },
  getters: {
    akses(state) {
      return state.akses;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/peran${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    form(_, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/peran/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/peran`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    // eslint-disable-next-line
    drop(_, { instansi_id, obj }) {
      return axios.delete(`${M_API}/instansi/${instansi_id}/akses/${obj.id}`).then(res => {
        return res.data;
      });
    }
  }
};

export default store;
